<template>
    <a class="people-item" href="javascript:{}" @click="go_to_person(person.id)">
        <div class="people-item-icon">
            <div v-if="person.avatar_url">
                <div
                    class="person-logo"
                    :style="{ backgroundImage: `url('${settings.api_url + '/resource/avatar/' + person.id}')` }"
                ></div>
            </div>
            <div v-else>
                <div class="people-item-icon-container" v-if="person.gender">
                    <span
                        :class="{ 'icon-man': person.gender === 'man', 'icon-woman': person.gender === 'woman' }"
                    ></span>
                </div>
                <div class="people-item-icon-container" v-else>
                    <span :class="{ 'icon-man': true }"></span>
                </div>
            </div>
        </div>
        <div class="people-item-content">
            <div class="people-item-content-top">{{ person.first_name }} {{ person.last_name }}</div>
            <div class="people-item-content-bottom">
                <div class="people-item-socials">
                    <a v-if="person.phone" :href="'tel:' + person.phone">
                        <span class="icon-phone"></span>
                    </a>
                    <a href="javascript:{}" v-if="person.email" :href="'mailto:' + person.email">
                        <span class="icon-envelope"></span>
                    </a>
                    <a target="_blank" href="javascript:{}" v-if="person.facebook" :href="person.facebook">
                        <span class="icon-fb"></span>
                    </a>
                </div>
            </div>
        </div>
        <div class="people-item-right">
            <span v-if="person.kids_count && person.kids_count > 0 && person.kids_count < 2"
                >{{ person.kids_count }} kid</span
            >
            <span v-if="person.kids_count && person.kids_count >= 2">{{ person.kids_count }} kids</span>
        </div>
    </a>
</template>

<script>
import router from "@/router";
import settings from "@/settings";

export default {
    name: "people-group",
    props: ["person"],
    data() {
        return {
            settings: settings
        };
    },
    methods: {
        go_to_person(person_id) {
            if (person_id) {
                router.push({ path: "/people/" + person_id });
            }
        }
    }
};
</script>

<style scoped>
.person-logo {
    width: 3.2rem;
    background-size: cover;
    height: 3.2rem;
    border-radius: 50%;
    background-position: 50% 50%;
    display: inline-block;
    background-repeat: no-repeat;
}
</style>
